import { ApiState, Action } from '../../../types';
import { Year } from '../../../services/types/Misc';
import { serviceReducer, callService } from '../../../shared/hooks/serviceReducer';

export interface YearQuery {
  query: string;
}

export type SearchYearAction =
  | Action<Year[], YearQuery>
  | {
      type: 'QUERY_YEAR';
      query: string;
    }
  | {
      type: 'SET_INITIAL_YEARS';
      initialYears: Year[];
    };

const reducer = (
  state: ApiState<Year[], YearQuery>,
  action: SearchYearAction
): ApiState<Year[], YearQuery> => {
  switch (action.type) {
    case 'QUERY_YEAR': {
      const filter = { query: action.query };
      return callService(state, filter);
    }
    case 'SET_INITIAL_YEARS': {
      const { initialYears } = action;
      return { ...state, data: initialYears };
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
